import { read } from "./storage";
import {
  STORE_KEY_USERNAME,
  STORE_KEY_USERINFO,
  STORE_KEY_CONFIG_LANG,
} from "./constants";

export const user            = read(STORE_KEY_USERNAME)    || "";
export const userInfo        = read(STORE_KEY_USERINFO)    || JSON.stringify({ user: "", name: "", person : "", email : "", phone : "", auth: false });
export const lang            = read(STORE_KEY_CONFIG_LANG) || process.env.VUE_APP_I18N_LOCALE || navigator.language.substr(0,2) || "bg";